import type { Map } from "mapbox-gl";
import React, { useMemo, useState, useContext } from "react";

type Topic = string;

interface GlobalStateContextProps {
  mapState: [
    Map | undefined,
    React.Dispatch<React.SetStateAction<Map | undefined>>,
  ];
  drawMapState: [
    Map | undefined,
    React.Dispatch<React.SetStateAction<Map | undefined>>,
  ];
  topicsState: [Topic[], React.Dispatch<React.SetStateAction<Topic[]>>];
  accessibilityState: [boolean, React.Dispatch<React.SetStateAction<boolean>>];
  translationsState: [
    Record<string, string>,
    React.Dispatch<React.SetStateAction<Record<string, string>>>,
  ];
  statefulCesiumMap: [
    any | undefined,
    React.Dispatch<React.SetStateAction<any | undefined>>,
  ];
}

const GlobalStateContext = React.createContext({} as GlobalStateContextProps);

const GlobalStateProvider = ({ children }) => {
  const mapState = useState<Map | undefined>();
  const drawMapState = useState<Map | undefined>();
  const topicsState = useState([] as Topic[]);
  const accessibilityState = useState(false);
  const translationsState = useState<string | undefined>();
  const statefulCesiumMap = useState<any | undefined>();

  const value = useMemo(() => {
    return {
      mapState,
      drawMapState,
      topicsState,
      accessibilityState,
      translationsState,
      statefulCesiumMap,
    };
  }, [
    mapState,
    drawMapState,
    topicsState,
    accessibilityState,
    translationsState,
    statefulCesiumMap,
  ]);

  return (
    <GlobalStateContext.Provider value={value}>
      {children}
    </GlobalStateContext.Provider>
  );
};

export const useGlobalState = () => useContext(GlobalStateContext);
export default GlobalStateProvider;
